export default "__VITE_ASSET__CRUpJmIS__"